import HandleRequest from "./HandleRequest";

const { postRequest } = HandleRequest();

export default function AuthService() {
  return {
    login: async (data: object) => postRequest("/api/login", data),
    forgotPassword: async (data: object) =>
      postRequest("/api/forgot-password", data),
  };
}
